<template>
  <div class="containor">
    <van-nav-bar class="title" title="家庭成员APP呼叫权限" left-text="返回" left-arrow @click-left="onClickLeft" />
    <h3>消息铃声设置</h3>
    <video width="100%" height="100%" style="width: 100%; height: 100%; object-fit: fill" controls>
      <source src="../../assets/video/FamilyMemberRights.mp4" type="video/mp4" />
    </video>
    <a :href="require('../../assets/video/FamilyMemberRights.mp4')">全屏观看</a>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar } from 'vant'
Vue.use(NavBar)
export default {
  name: 'huawei',
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="less" scoped>
.containor {
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow-x: hidden;
  align-items: center;
  padding: 0 5px 15px 5px;

  h1 {
    margin-top: 20rem;
    font-size: 32px;
  }

  p {
    max-width: 900px;
    line-height: 2rem;
    font-size: 14px;
    margin: auto;
  }
}

.title {
  width: 100%;
}
</style>
